import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class RareConditionsBrowser extends ConditionRegistryCategory {
    label = 'Browser';
    constructor(parent) {
        super(parent);
        super.init();
    }
    Rare_isOldEdge = () => new ConditionRegistryItem({
        parent: this,
        label: 'is old Edge Browser',
        eval: () => {
            return runtime.browserRuntime && runtime.browserRuntime.browserAgent.isOldEdge;
        }
    });
}
